import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LayoutComponent } from '@ipensii/layout/ui-layout';
import { Store } from '@ngrx/store';
import { SharedActions } from '@ipensii/shared/feature-shared-state';
import { LoadingBarComponent } from '@ipensii/shared/ui-shared';
import { ToastModule } from 'primeng/toast';

@Component({
  standalone: true,
  imports: [RouterModule, LayoutComponent, LoadingBarComponent, ToastModule],
  selector: 'ip-root',
  templateUrl: 'ipensii-app.component.html',
})
export class IpensiiAppComponent {
  constructor() {
    const store = inject(Store);
    store.dispatch(SharedActions.ComponentInfo.loadComponentInfo());
    store.dispatch(SharedActions.Provider.loadProviders());
  }
}
